import AmbassadorSignup from "./ambassadorSignup";
import AmbassadorJoin from "./ambassadorJoin";
import Careers from "./careers";
import EnterpriseSignup from "./enterpriseSignup";
import EnterpriseJoin from "./enterpriseJoin";
import EnterpriseSellerJoin from "./enterpriseSellerJoin";
import FAQ from "./faq";
import HomeLight from "./homeLight";
import WhySolar from "./whySolar";
import EnergyStorage from "./energyStorage";
import InstallerJoin from "./installerJoin";
import SellerSignup from "./sellerSignup";
import Join from "./join";
import Licenses from "./licenses";
import Partners from "./partners";
import Password from "./password";
import PrivacyPolicy from "./privacyPolicy";

import Team from "./team";
import ContactVerification from "./contactVerification";

const educationRedirects = [
  { key: "education-redirect", path: "/:user?/education", redirect: true },
  { key: "education-redirect-wildcard", path: "/:user?/education/:subpage", redirect: true },
];

export default [
  ...educationRedirects,
  AmbassadorSignup,
  AmbassadorJoin,
  Careers,
  EnterpriseSignup,
  EnterpriseJoin,
  EnterpriseSellerJoin,
  FAQ,
  HomeLight,
  WhySolar,
  EnergyStorage,
  InstallerJoin,
  SellerSignup,
  Join,
  Licenses,
  Partners,
  Password,
  PrivacyPolicy,

  Team,
  ContactVerification,
];
